import Web3 from "web3"
import { useState,useEffect } from "react";
export default function Nutrition() {


    const [balance, setBalance] = useState(0);

    async function loadData(){
        let web3 = new Web3("https://bsc-dataseed.binance.org/");
        //GET BALANCE OF aDDRESS
        let BALANCE = await web3.eth.getBalance("0xF61441F0373d012CE2AF3FF55D13294B5f71dd2E");
        setBalance((BALANCE / 1000000000000000000).toFixed(2));
    }

    useEffect(()=>{
        loadData();
    },[]);

    

    return (
        <div className="nutrition-container container slide-in-right">
            <h2>Facts</h2>

            <div className="flex-row">
                <h3>Daily Return</h3>
                <h3>8%</h3>
            </div>
            <div className="flex-row">
                <h3>APR</h3>
                <h3>2,920%</h3>
            </div>
            <div className="flex-row">
                <h3>Dev Fee</h3>
                <h3>3%</h3>
            </div>
            <div className="flex-row">
                <h3>Chest</h3>
                <h3>{balance} BNB</h3>
            </div>
        </div>
    )
}